import type { EventEmitter } from '@angular/core';
import { InjectionToken } from '@angular/core';

import type { ISelectController, SelectResolvedTemplate } from '../../types';

export interface MultiselectFeature {
  chipRemoved: EventEmitter<void>;
  selectController: ISelectController;
  selectedItemCounterDirective: SelectResolvedTemplate;
}

export const MULTISELECT_FEATURE = new InjectionToken<MultiselectFeature>('multiselect feature');
